export const PAGE_ACCESS_OPTIONS = [
  {
    group: 'Main',
    pages: [
      { name: 'Dashboard', path: '/' },
      { name: 'Masters', path: '/masters' },
      { name: 'Reports', path: '/reports' },
      { name: 'Summary', path: '/summary' },
      { name: 'Updation', path: '/updation' },
      { name: 'Issue Stock', path: '/issue_stock' },
      { name: 'Manufacturing Menu', path: '/Mfg' },
      { name: 'Settings', path: '/settings' },
    ],
  },
  {
    group: 'Masters',
    pages: [
      { name: 'Department Master', path: '/department_master' },
      { name: 'Item Master', path: '/item_master' },
      { name: 'Party Master', path: '/party_master' },
      { name: 'Expense Master', path: '/Expense_Master' },
      { name: 'Party Rate Master', path: '/party_rate_master' },
      { name: 'Shopkeeper Price List', path: '/shopkeeper_price_list' },
      { name: 'Station Master', path: '/station_master' },
      { name: 'Employee Master', path: '/Employee_Master' },
      { name: 'Station Item Master', path: '/station_item_master' },
      { name: 'RFID Code Master', path: '/rfid_code_master' },
      { name: 'Template Master', path: '/Template_master' },
    ],
  },
  {
    group: 'Reports',
    pages: [
      { name: 'Route Alert Report', path: '/Route_Alert_Report' },
      { name: 'Item Wise Sale Report', path: '/Item_Wise_Sale_Report' },
      { name: 'Item Wise Issue Report', path: '/item_Wise_issue_report' },
      { name: 'Party Balance Report', path: '/Party_Balance_Report' },
      { name: 'Party Wise Balance Report', path: '/Party_Wise_Balance_Report' },
      { name: 'Non Purchase Parties', path: '/non_purchasing_parties' },
      { name: 'Party Ledger', path: '/Party_Ledger' },
      { name: 'Sales Map', path: '/salesMap' },
      { name: 'All Stations Balance Report', path: '/All_Stations_Balance_Report' },
      { name: 'Difference Report', path: '/Difference_report' },
      { name: 'Station Balance Mismatch', path: '/Station_Balance_Mismatch' },
      { name: 'Station Day End Reports', path: '/Station_day_end_reports' },
      { name: 'Station Outstanding', path: '/Station_outstanding' },
      { name: 'Profit Report', path: '/Profit_report' },
      { name: 'Profit Summary', path: '/Profit_summary' },
      { name: 'Flow Transaction Summary', path: '/Flow_Transaction_Report_Sum' },
      { name: 'Flow Transaction Report', path: '/Flow_Transaction_Report' },
    ],
  },
  {
    group: 'Summary / Update',
    pages: [
      { name: 'Sale Summary', path: '/Sale_Summary' },
      { name: 'Day End Summary', path: '/day_end_summary' },
      { name: 'Collection Summary', path: '/collection_summary' },
      { name: 'Payment Receipt Summary', path: '/payment_reciept_summary' },
      { name: 'Update Party Item Rate', path: '/Update_Party_Item_Rate' },
      { name: 'Update Item Rate Station Wise', path: '/Update_Item_Rate_Station_Wise' },
      { name: 'Expense Voucher', path: '/Expense_Voucher' },
      { name: 'Collection Voucher', path: '/Collection_Voucher' },
    ],
  },
  {
    group: 'Admin / Settings',
    pages: [
      { name: 'Company Master', path: '/company_master' },
      { name: 'User Master', path: '/user_master' },
      { name: 'Shopkeeper Master', path: '/shopkeeper_master' },
      { name: 'User Profile', path: '/user_profile' },
      { name: 'User Scope Master', path: '/User_scope_master' },
      { name: 'Whatsapp Sender Master', path: '/whatsapp_sender_master' },
      { name: 'Promo Messenger Master', path: '/promo_messanger_master' },
      { name: 'Send Promo Message', path: '/send_promo_message' },
      { name: 'Message Setup Master', path: '/Message_Setup_Master' },
      { name: 'Announcement Setup', path: '/announcement_setup' },
    ],
  },
  {
    group: 'Manufacturing',
    pages: [
      { name: 'Manufacturing', path: '/Manufacturing' },
      { name: 'Manufacturing Summary', path: '/Manufacturing_Summary' },
      { name: 'Order Booking', path: '/order_booking' },
      { name: 'Mfg Balance Report', path: '/Mfg_balance_report' },
      { name: 'Order Summary', path: '/Order_summary' },
    ],
  },
];

export const PAGE_ACCESS_BY_MENU = {
  Dashboard: ['/'],
  Masters: ['/masters', '/department_master', '/item_master', '/party_master', '/Expense_Master', '/party_rate_master', '/shopkeeper_price_list', '/station_master', '/Employee_Master', '/station_item_master', '/rfid_code_master', '/Template_master'],
  Reports: ['/reports', '/Route_Alert_Report', '/Item_Wise_Sale_Report', '/item_Wise_issue_report', '/Party_Balance_Report', '/Party_Wise_Balance_Report', '/non_purchasing_parties', '/Party_Ledger', '/salesMap', '/All_Stations_Balance_Report', '/Difference_report', '/Station_Balance_Mismatch', '/Station_day_end_reports', '/Station_outstanding', '/Profit_report', '/Profit_summary', '/Flow_Transaction_Report_Sum', '/Flow_Transaction_Report'],
  Summary: ['/summary', '/Sale_Summary', '/day_end_summary', '/collection_summary', '/payment_reciept_summary'],
  Updation: ['/updation', '/Update_Party_Item_Rate', '/Update_Item_Rate_Station_Wise', '/Expense_Voucher', '/Collection_Voucher'],
  'Issue Stock': ['/issue_stock'],
  Manufacturing: ['/Mfg', '/Manufacturing', '/Manufacturing_Summary', '/order_booking', '/Mfg_balance_report', '/Order_summary'],
  'Mfg.Summary': ['/Manufacturing_Summary'],
  'Company Master': ['/company_master'],
  'User Master': ['/user_master'],
  Settings: ['/settings', '/User_scope_master', '/whatsapp_sender_master', '/Message_Setup_Master', '/announcement_setup'],
  'Messanger Master': ['/promo_messanger_master'],
  'Send Promo': ['/send_promo_message'],
};

export const parseAllowedPages = (pages) => {
  if (Array.isArray(pages)) return pages.filter(Boolean);
  if (!pages) return [];
  return String(pages)
    .split(',')
    .map((page) => page.trim())
    .filter(Boolean);
};

export const hasPageAccess = (userType, allowedPages, path) => {
  if (userType === 'ADMIN') return true;

  const pages = parseAllowedPages(allowedPages);
  if (!pages.length) return true;

  return pages.includes(path);
};

export const hasMenuAccess = (userType, allowedPages, menuName) => {
  if (userType === 'ADMIN') return true;

  const pages = parseAllowedPages(allowedPages);
  if (!pages.length) return true;

  const menuPages = PAGE_ACCESS_BY_MENU[menuName] || [];
  return menuPages.some((path) => pages.includes(path));
};
